import {
  Box,
  Select,
  MenuItem,
  InputLabel,
  Typography,
  FormControl,
} from "@mui/material";
import { useState } from "react";
export default function InspLabelDetailFilter({
  selectAvi,
  selectAi,
  selectHr,
  setSelectAvi,
  setSelectAi,
  setSelectHr,
  filter,
}) {
  const labelList = [
    { label: "AVI", value: "avi" },
    { label: "AI", value: "ai" },
    { label: "HR", value: "hr" },
  ];

  const handleSelectChange = (labelValue, value) => {
    switch (labelValue) {
      case "avi":
        setSelectAvi(value);
        break;
      case "ai":
        setSelectAi(value);
        break;
      case "hr":
        setSelectHr(value);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      {labelList
        .filter((label) => filter[label.value])
        .map((label) => (
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth>
              <InputLabel>{label.label}</InputLabel>
              <Select
                variant="outlined"
                value={
                  label.value === "avi"
                    ? selectAvi || "a"
                    : label.value === "ai"
                    ? selectAi || "a"
                    : selectHr || "a"
                }
                onChange={(e) =>
                  handleSelectChange(label.value, e.target.value)
                }
                sx={{ width: "100%" }}
              >
                <MenuItem key="a" value="a">
                  선택하세요
                </MenuItem>
                <MenuItem key="OK" value="OK">
                  OK
                </MenuItem>
                <MenuItem key="NG" value="NG">
                  NG
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        ))}
    </Box>
  );
}
